module.exports = __webpack_public_path__ + "img/EP.735afa86.png";